module.exports = __webpack_public_path__ + "static/media/JohnsManville.4b0b1af3.svg";